import React from 'react';
import { motion } from 'framer-motion';
import { Search, Users, Bot, BarChart3, RefreshCw, LineChart } from 'lucide-react';
const services = [{
  title: 'Google Ads',
  description: 'Captamos clientes listos para comprar mediante campañas optimizadas.',
  icon: Search
}, {
  title: 'CRM',
  description: 'Organizamos y automatizamos todo tu proceso comercial.',
  icon: Users
}, {
  title: 'Inteligencia Artificial Aplicada al Marketing',
  description: 'Automatización de respuestas, seguimiento y generación de oportunidades.',
  icon: Bot
}, {
  title: 'Google Analytics',
  description: 'Datos reales para tomar decisiones rentables.',
  icon: BarChart3
}, {
  title: 'Remarketing',
  description: 'Recuperamos visitantes que no compraron.',
  icon: RefreshCw
}, {
  title: 'Optimización de Conversiones',
  description: 'Transformamos más tráfico en clientes.',
  icon: LineChart
}];
export function Services() {
  return <section id="servicios" className="py-24 bg-brand-cyan/5" data-id="element-216">
      <div className="container mx-auto px-6 md:px-12" data-id="element-217">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-218">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-219">
            Soluciones para escalar tu negocio
          </motion.h2>
          <div className="w-20 h-1 bg-brand-cyan mx-auto rounded-full" data-id="element-220" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-221">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={service.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group bg-white rounded-2xl p-8 border border-slate-100 shadow-sm hover:shadow-card hover:border-brand-cyan/30 transition-all duration-300 relative overflow-hidden" data-id="element-222">
                {/* Subtle hover background glow */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-brand-cyan/5 rounded-full blur-2xl -mr-10 -mt-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-223" />

                <div className="w-14 h-14 rounded-xl bg-slate-50 flex items-center justify-center mb-6 group-hover:bg-brand-cyan/10 transition-colors duration-300" data-id="element-224">
                  <Icon size={28} className="text-brand-black group-hover:text-brand-cyan transition-colors duration-300" data-id="element-225" />
                </div>

                <h3 className="text-xl font-bold mb-3 group-hover:text-brand-cyan transition-colors duration-300" data-id="element-226">
                  {service.title}
                </h3>

                <p className="text-slate-600 leading-relaxed" data-id="element-227">
                  {service.description}
                </p>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-0 w-0 h-1 bg-brand-cyan group-hover:w-full transition-all duration-500 ease-out" data-id="element-228" />
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}